
import React from 'react';
import Select from 'react-select';

export default function DispositionsSelector(props) {
    const [dispositions, setDispositions] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [selected, setSelected] = React.useState(null);

    const {
        ajax_load= true,
        dispositions_loaded= [],
        selectClass= null,
        allPax= [],
        trad= TRAD.DispositionsSelector ?? {},
        defaultValue,
        label,
        onLoad,
        onChange,
        name
    } = props;

    const selectStyles = {
        menu: base => ({
            ...base,
            marginTop: 0,
            'z-index': 10
        })
    };

    React.useEffect(() => {
        if (ajax_load) {
            let url = ENV.base_lang_url + "myspace/providers//ajaxGetter/get_meeting_rooms_types";
            fetch(url, {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
            })
                .then(rtn => rtn.json())
                .then(result => {
                    setDispositions(result);
                    handleLoad(result);
                });
        } else {
            setDispositionsFromProps();
        }
    }, []);


    React.useEffect(() => {
        if(dispositions.length > 0) {

            let disposition_selected = null;
            disposition_selected = dispositions.filter((dispo) => {
                return dispo.value == defaultValue;
            });
            
            let newSelected = null;
            if (disposition_selected.length > 0) {
                newSelected = disposition_selected[0];
            } else {
                newSelected = dispositions[0];
            }

            handleChange(newSelected);

            setIsLoaded(true);
        }
    }, [defaultValue, dispositions]);

    React.useEffect(() => {
        setDispositionsFromProps(dispositions_loaded);
    }, [dispositions_loaded]);



    const setDispositionsFromProps = ()  => {
        if (!ajax_load && !isLoaded && dispositions_loaded.length > 0) {
            setDispositions(dispositions_loaded);
            handleLoad(dispositions_loaded);
            setIsLoaded(true);
        }
    }

    const handleChange = (disposition) => {
        setSelected(disposition);
        if (onChange) {
            onChange(disposition);
        }
    };

    const handleLoad = (all_dispositions) => {

        if (onLoad) {
            onLoad(all_dispositions);
        }
    };

    let options = [];
    
    dispositions.map((dispo) => {
        let pax = allPax[dispo.value] ?? 0;
        if (pax > 0) {
            dispo.label = dispo.label_without_pax + ' (' + trad.max_pax + ' : ' + pax + ')';
        } else {
            dispo.label = dispo.label_without_pax;
        }
        options.push(dispo);
    });

    return (
        <div className={(selected && selected.value != '') ? 'text-gc-green' : 'text-gc-orange'}>
            {label && <label>{label}</label>}
            <Select
                options={options}
                onChange={handleChange}
                value={selected ? selected : ''}
                name={name}
                classNamePrefix="react-select"
                placeholder={trad.placeholder}
                styles={selectStyles}
            >
            </Select>
        </div>
    )
}